/**
 * Realtime helper functions (Worker WebSocket)
 */

function normalizePath(pathname) {
  if (!pathname) return "/";
  if (pathname.startsWith("/")) return pathname;
  return `/${pathname}`;
}

function trimTrailingSlashes(value) {
  return String(value || "").replace(/\/+$/, "");
}

function normalizeWsPathname(pathname) {
  const path = normalizePath(pathname || "/").replace(/\/+$/, "") || "/";
  const lowerPath = path.toLowerCase();

  if (path === "/") return "/api/ws";
  if (lowerPath.endsWith("/ws")) return path;
  if (lowerPath === "/api") return "/api/ws";
  return path;
}

export function resolveRealtimeWsUrl() {
  const wsBase = trimTrailingSlashes(import.meta.env.VITE_WS_BASE || "");
  if (wsBase) {
    if (
      typeof window === "undefined" &&
      !/^wss?:\/\//i.test(wsBase) &&
      !/^https?:\/\//i.test(wsBase)
    ) {
      return "";
    }

    const url = wsBase.startsWith("ws://") ||
      wsBase.startsWith("wss://") ||
      wsBase.startsWith("http://") ||
      wsBase.startsWith("https://")
      ? new URL(wsBase)
      : new URL(wsBase, window.location.origin);
    if (url.protocol === "http:") url.protocol = "ws:";
    if (url.protocol === "https:") url.protocol = "wss:";
    url.pathname = normalizeWsPathname(url.pathname);
    return url.toString();
  }

  const apiBaseRaw = String(import.meta.env.VITE_API_BASE || "/api").trim();
  if (typeof window === "undefined") return "";

  const base = apiBaseRaw
    ? new URL(apiBaseRaw, window.location.origin)
    : new URL("/api", window.location.origin);
  base.protocol = base.protocol === "https:" ? "wss:" : "ws:";
  base.pathname = `${normalizePath(base.pathname).replace(/\/+$/, "")}/ws`;
  base.search = "";
  return base.toString();
}

export function isRealtimeConfigured() {
  return Boolean(resolveRealtimeWsUrl());
}

export function getBackoffDelay(retryCount) {
  return Math.min(30_000, 1_000 * 2 ** retryCount);
}
